<div
  class="assistant-instructions-container {{ instructionsMode() }}"
  [ngClass]="{ 'assistant-instructions-expanded-view': styleSize == 'expanded' }"
>
  <div class="assistant-sub-header with-button">
    <div>Instructions</div>
    <u-button
      type="secondary"
      [label]="'Switch to ' + (instructionsMode() === 'advanced' ? 'Default' : 'Advanced')"
      [elementSize]="'small28'"
      (onClick)="changeMode()"
      [disabled]="disabled"
    >
    </u-button>
  </div>
  @switch (instructionsMode()) {
    @case ('advanced') {
      <div class="advanced-mode-container">
        <div class="advanced-mode-title">
          <span>{{ dynamicContent?.advancedTitle }}</span>
          <u-button
            [label]="'Learn More'"
            type="link"
            (mousedown)="openLearnMore()"
            [styles]="{ fontSize: styleSize == 'expanded' ? '14px' : '12px' }"
          ></u-button>
        </div>
        <u-textarea-interactive
          class="advanced-mode-textarea"
          [styles]="{ maxHeight: '138px', minHeight: '100px' }"
          [placeholder]="dynamicContent?.advancedPlaceholder"
          [model]="customQuery()"
          [disabled]="disabled"
          [maxLength]="maxCharactersCustomQuery()"
          [rows]="6"
          [maxRowLimit]="6"
          [minHeight]="100"
          [autofocus]="false"
          [ignoreEnter]="true"
          [displayLimitWarning]="true"
          [rightSideTemplate]="rightSideTemplate"
          (onChange)="onCustomQueryChange($event)"
        ></u-textarea-interactive>
        <div class="advanced-mode-subtitle">{{ ASSISTANT_INSTRUCTIONS_CONTENT.advancedQueryWarning }}</div>
      </div>
    }
    @case ('default') {
      <div class="default-mode-container">
        @if (displayInstructions()?.has('answerDetailLevel')) {
          <div class="configuration-container">
            <div class="configuration-title">Response length</div>
            <u-dropdown
              [options]="ASSISTANT_INSTRUCTIONS_CONTENT.optionsResponseLength"
              [selectedValue]="selectedResponseLength"
              [dropdownSelectIcon]="selectedResponseLength?.icon"
              optionLabel="label"
              optionalSubLabel="subLabel"
              dropdownSize="medium"
              (onChange)="onDropDownChanged($event, 'answerDetailLevel')"
              [styles]="DROPDOWN_STYLE"
              [disabled]="disabled"
              [itemIconStyle]="ITEM_ICON_STYLE"
              [selectedItemIconStyle]="ITEM_ICON_STYLE"
              [appendTo]="'body'"
              placeholder="selectedResponseLength.label"
            >
            </u-dropdown>
          </div>
        }
        @if (displayInstructions()?.has('answerTone')) {
          <div class="configuration-container">
            <div class="configuration-title">Adjust tone</div>
            <u-dropdown
              [options]="ASSISTANT_INSTRUCTIONS_CONTENT.optionsAdjustTone"
              [selectedValue]="selectedAdjustTone"
              [dropdownSelectIcon]="selectedAdjustTone?.icon"
              optionLabel="label"
              dropdownSize="medium"
              (onChange)="onDropDownChanged($event, 'answerTone')"
              [styles]="DROPDOWN_STYLE"
              [disabled]="disabled"
              [itemIconStyle]="ITEM_ICON_STYLE"
              [selectedItemIconStyle]="ITEM_ICON_STYLE"
              [appendTo]="'body'"
              placeholder="selectedAdjustTone.label"
            >
            </u-dropdown>
          </div>
        }
      </div>
    }
  }
</div>

<ng-template #rightSideTemplate>
  <u-button
    class="inline-extra-icon"
    [versionNumber]="2"
    typeElement="secondary"
    fontIcon="expand2"
    [styleType]="'outlined'"
    [sizeElement]="'small'"
    (onClick)="openAdvancePopup()"
  ></u-button>
</ng-template>
